import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=1f96d980&scoped=true&"
import script from "./Tracking.vue?vue&type=script&lang=js&"
export * from "./Tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96d980",
  null
  
)

export default component.exports